import type React from 'react';
import { useEffect, useRef } from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number;
  width?: string | number;
  height?: string | number;
  color?: string;
  fill?: string;
  stroke?: string;
}

export function Link(props: IconProps) {
  const root = useRef<SVGSVGElement>(null);
  const { size = '1em', width, height, color, fill, stroke, ...rest } = props;
  const _width = width || size;
  const _height = height || size;
  const _stroke = stroke || color;
  const _fill = fill || color;
  useEffect(() => {
    if (!_fill) {
      (root.current as SVGSVGElement)?.querySelectorAll('[data-follow-fill]').forEach((item) => {
        item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
      });
    }
    if (!_stroke) {
      (root.current as SVGSVGElement)?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
        item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
      });
    }
  }, [stroke, color, fill]);
  return (
    <svg
      ref={root}
      width={_width}
      height={_height}
      viewBox="0 0 24 24"
      fill="none"
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.8132 13.12L20.3832 8.54997C21.7138 7.21932 21.6845 5.03257 20.3177 3.66571C18.9509 2.29887 16.7641 2.26956 15.4334 3.60024L11.4658 7.56787"
        data-follow-stroke="currentColor"
        stroke={_stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.498 16.4515L8.5304 20.4192C7.1997 21.7499 5.01295 21.7205 3.6461 20.3537C2.27925 18.9869 2.24995 16.8001 3.58065 15.4694L8.15065 10.8994"
        data-follow-stroke="currentColor"
        stroke={_stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10.9292 13.0547C12.296 14.4215 14.4828 14.4508 15.8135 13.1202"
        data-follow-stroke="currentColor"
        stroke={_stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13.1006 10.8996C11.7337 9.53276 9.54699 9.50346 8.21634 10.8341"
        data-follow-stroke="currentColor"
        stroke={_stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
